import { FC, useContext, useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { NetworkSubmissionContext } from "@app/compliance-connect/network-submission/NetworkSubmissionContext";
import { NetworkSubmissionWizardAction } from "@app/compliance-connect/network-submission/networkSubmissionWizardActions";
import NetworkSubmissionService from "@app/compliance-connect/network-submission/networkSubmissionService";
import { UserContext } from "@app/user/UserContext";

export const NetworkSubmissionStepSelectRegulator: FC = () => {
  const wizardContext = useContext(NetworkSubmissionContext);
  const user = useContext(UserContext);
  const networkSubmissionService = useRef(new NetworkSubmissionService()).current;

  const { data: regulatorsData, isLoading: regulatorsLoading } = useQuery({
    queryFn: ({ signal }) => networkSubmissionService.getRegulators(signal),
    queryKey: ["ns-regulators", user?.userId, user?.clientId],
  });

  const regulators = regulatorsData ?? [];
  const noRegulatorsAvailable = !regulatorsLoading && regulators.length === 0;

  useEffect(() => {
    if (regulators.length === 1 && wizardContext.regulatorClientId === null) {
      wizardContext.dispatch({ payload: regulators[0].clientId, type: NetworkSubmissionWizardAction.SetRegulatorClientId });
    }
  }, [regulators, wizardContext.dispatch, wizardContext.regulatorClientId]);

  return (
    <div className="row mt-2">
      <div className="col-7">
        <div className="mb-4">
          <h6 className="demibold mb-3">Regulator Receiving Submission<span className="text-danger"> *</span></h6>
          <p className="text-muted">Select regulator for network submission:</p>
          <QESSelect
            label="Regulator Receiving Submission"
            hideLabel={true}
            testId="ns-select-regulator__regulators"
            disabled={regulators.length <= 1}
            required={true}
            isValid={wizardContext.regulatorClientId !== null}
            unrequiredValidation={true}
            wasFocusedExternally={noRegulatorsAvailable}
            placeholder={regulatorsLoading ? "Loading..." : ""}
            errorText={noRegulatorsAvailable
              ? "No regulators are associated with your client. Contact support to configure one."
              : "A regulator must be selected."}
            value={wizardContext.regulatorClientId ?? ""}
            onChange={(e) => {
              const val = e.target.value;
              wizardContext.dispatch({ payload: val ? parseInt(val, 10) : null, type: NetworkSubmissionWizardAction.SetRegulatorClientId });
            }}
          >
            {regulators.map((r) => (
              <option key={r.clientId} value={r.clientId}>{r.name}</option>
            ))}
          </QESSelect>
        </div>
      </div>
    </div>
  );
};
